import React, { useCallback, useEffect, useState } from 'react';
import { BellRing, Plus, Save, Send, Trash2, Moon } from 'lucide-react';
import { jarvis, formatarTelefone, hora } from './api';
import './avisos.css';

// Supervisor → Avisos WhatsApp: o Quality avisa pelo número do Jarvis quando a pessoa recebe
// tarefa nova, convite de agenda, mudança de compromisso ou recusa de convite.
const TIPOS = [
  ['nova_tarefa', '📋 Tarefa nova atribuída', 'Projeto IW, Projeto Homecare, Projeto Direção, Obras e Tarefas da Qualidade'],
  ['convite_agenda', '📅 Convite novo de agenda', 'Agenda pessoal, Direção, Qualidade e Homecare'],
  ['alteracao_agendamento', '🔁 Compromisso alterado', 'Mudança de data ou horário'],
  ['recusa_convite', '❌ Convite recusado', 'Alguém recusou um convite seu'],
];
const ROTULO = Object.fromEntries(TIPOS.map(([k, r]) => [k, r]));
ROTULO.teste = '👋 Teste';

export default function AvisosWhatsapp({ setErro, avisar }) {
  const [d, setD] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [nova, setNova] = useState(null);
  const [ocupado, setOcupado] = useState('');

  const carregar = useCallback(() => jarvis('avisos').then(setD).catch(e => setErro(e.message)), [setErro]);
  useEffect(() => {
    carregar();
    jarvis('usuarios').then(r => setUsuarios(r.usuarios)).catch(() => {});
    const t = setInterval(() => { if (document.visibilityState !== 'hidden') carregar(); }, 20000);
    return () => clearInterval(t);
  }, [carregar]);

  const acao = async (nome, dados, msg) => {
    setOcupado(nome); setErro('');
    try { setD(await jarvis(nome, dados)); if (msg) avisar(msg); } catch (e) { setErro(e.message); }
    setOcupado('');
  };

  if (!d) return <div className="jv-carregando">Carregando…</div>;
  const cfg = d.config;
  const mudarCfg = novo => setD({ ...d, config: { ...cfg, ...novo } });
  const cadastrados = new Set(d.pessoas.map(p => p.email));

  return (
    <>
      <div className="jv-cartao">
        <div className="jv-cartao-cab">
          <h3><BellRing size={18} /> Avisos do Quality pelo WhatsApp</h3>
          <button className="jv-btn jv-btn-primario" disabled={!!ocupado} onClick={() => acao('salvarAvisosConfig', { config: cfg }, cfg.ligado ? 'Avisos ligados.' : 'Configuração salva (avisos desligados).')}>
            <Save size={16} /> Salvar
          </button>
        </div>
        <p className="jv-sub">Os avisos saem pelo número do Jarvis (ele precisa estar conectado) só para as pessoas cadastradas abaixo, e só do que acontecer depois do cadastro.</p>
        <label className={`jv-interruptor ${cfg.ligado ? 'on' : ''}`}>
          <input type="checkbox" checked={!!cfg.ligado} onChange={e => mudarCfg({ ligado: e.target.checked })} />
          <span className="jv-interruptor-bola" />
          <b>{cfg.ligado ? 'Avisos LIGADOS' : 'Avisos desligados'}</b>
        </label>
        <div className="jv-tipos-aviso">
          {TIPOS.map(([k, r, desc]) => (
            <label key={k} className="jv-check jv-tipo-aviso">
              <input type="checkbox" checked={cfg.tipos?.[k] !== false} onChange={e => mudarCfg({ tipos: { ...cfg.tipos, [k]: e.target.checked } })} />
              <span><b>{r}</b><br /><span className="jv-sub">{desc}</span></span>
            </label>
          ))}
        </div>
        <div className="jv-linha-campos">
          <label className="jv-check"><input type="checkbox" checked={!!cfg.silencio?.ativo} onChange={e => mudarCfg({ silencio: { ...cfg.silencio, ativo: e.target.checked } })} /><Moon size={15} /> Não enviar entre</label>
          <input type="time" value={cfg.silencio?.ini || '22:00'} onChange={e => mudarCfg({ silencio: { ...cfg.silencio, ini: e.target.value } })} />
          e
          <input type="time" value={cfg.silencio?.fim || '07:00'} onChange={e => mudarCfg({ silencio: { ...cfg.silencio, fim: e.target.value } })} />
          <span className="jv-sub">(o que acontecer nesse horário é enviado quando terminar o silêncio)</span>
        </div>
      </div>

      <div className="jv-cartao">
        <div className="jv-cartao-cab">
          <h3>Quem recebe</h3>
          <button className="jv-btn jv-btn-primario" onClick={() => setNova({ email: '', nome: '', telefone: '', ativo: true })}><Plus size={16} /> Adicionar pessoa</button>
        </div>
        {nova && (
          <div className="jv-form-inline">
            <div className="jv-linha-campos">
              <label className="jv-campo">Usuário do Quality
                <select value={nova.email} onChange={e => { const u = usuarios.find(x => x.email === e.target.value); setNova({ ...nova, email: e.target.value, nome: u?.nome || '' }); }}>
                  <option value="">Escolha…</option>
                  {usuarios.filter(u => !cadastrados.has(u.email) || u.email === nova.email).map(u => <option key={u.email} value={u.email}>{u.nome} — {u.email}</option>)}
                </select>
              </label>
              <label className="jv-campo jv-campo-m">WhatsApp (DDD + número)<input value={nova.telefone} placeholder="21 99999-9999" onChange={e => setNova({ ...nova, telefone: e.target.value })} /></label>
            </div>
            <div className="jv-modal-rodape">
              <button className="jv-btn" onClick={() => setNova(null)}>Cancelar</button>
              <button className="jv-btn jv-btn-primario" disabled={!nova.email || !nova.telefone || !!ocupado}
                onClick={() => acao('salvarAvisoPessoa', { pessoa: nova }, 'Pessoa cadastrada.').then(() => setNova(null))}><Save size={16} /> Salvar</button>
            </div>
          </div>
        )}
        <table className="jv-tabela">
          <thead><tr><th>Pessoa</th><th>WhatsApp</th><th>Recebendo</th><th>Desde</th><th /></tr></thead>
          <tbody>
            {d.pessoas.length === 0 && <tr><td colSpan={5} className="jv-sub">Ninguém cadastrado. Comece por você mesmo para testar.</td></tr>}
            {d.pessoas.map(p => (
              <tr key={p.email}>
                <td><b>{p.nome}</b><br /><span className="jv-sub">{p.email}</span></td>
                <td>{formatarTelefone(p.telefone)}</td>
                <td>
                  <label className="jv-check"><input type="checkbox" checked={p.ativo} disabled={!!ocupado}
                    onChange={e => acao('salvarAvisoPessoa', { pessoa: { ...p, ativo: e.target.checked } })} /> {p.ativo ? 'sim' : 'pausado'}</label>
                </td>
                <td>{hora(p.ativado_em)}</td>
                <td className="jv-acoes-linha">
                  <button className="jv-btn" disabled={!!ocupado} onClick={() => acao('testarAviso', { email: p.email }, `Teste enviado para ${p.nome}.`)}><Send size={15} /> Enviar teste</button>
                  <button className="jv-icone" title="Tirar da lista" onClick={() => window.confirm(`Tirar ${p.nome} dos avisos?`) && acao('apagarAvisoPessoa', { email: p.email })}><Trash2 size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="jv-cartao">
        <h3>Últimos avisos</h3>
        <table className="jv-tabela">
          <thead><tr><th>Quando</th><th>Para</th><th>Tipo</th><th>Mensagem</th><th>Situação</th></tr></thead>
          <tbody>
            {d.historico.length === 0 && <tr><td colSpan={5} className="jv-sub">Nenhum aviso enviado ainda.</td></tr>}
            {d.historico.map(h => (
              <tr key={h.id}>
                <td>{hora(h.criado_em)}</td>
                <td>{h.nome}</td>
                <td>{ROTULO[h.tipo] || h.tipo}</td>
                <td className="jv-td-texto" title={h.texto}>{String(h.texto || '').replace(/\*/g, '').split('\n').slice(0, 2).join(' · ')}</td>
                <td>{h.status !== 'enviado'
                  ? <span style={{ color: '#b91c1c' }} title={h.erro || ''}>✗ erro (tenta de novo)</span>
                  : h.lido_em ? <span style={{ color: '#2563eb', fontWeight: 700 }} title={`Lida em ${new Date(h.lido_em).toLocaleString('pt-BR')}`}>✓✓ lida</span>
                  : h.entregue_em ? <span className="jv-verde" title={`Chegou em ${new Date(h.entregue_em).toLocaleString('pt-BR')}`}>✓✓ chegou</span>
                  : <span className="jv-verde" title="O WhatsApp aceitou a mensagem; a confirmação de entrega aparece quando o celular da pessoa recebe">✓ enviado</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
